import { useRef, useState } from "react";
import { formatDateForInput, parseDateString } from "../constant";
import {
  FaCheckCircle,
  FaFileExcel,
  FaFilePdf,
  FaPrint,
  FaSearch,
  FaStar,
} from "react-icons/fa";
import SidebarComponent from "./Sidebar";
import useAxios from "../common/hook/useAxios";
import { AiOutlineFileExcel } from "react-icons/ai";
import { MdPictureAsPdf } from "react-icons/md";
import { toast } from "react-toastify";

const LabCompliancePopup = ({
  fromDate,
  setFromDate,
  toDate,
  setToDate,
  tableData,
  handleSearch,
}) => {
  const tableRef = useRef(null);
  const { request } = useAxios();
  const [searchTerm, setSearchTerm] = useState("");
  const [error, setError] = useState("");
  const filteredPatients =
    tableData?.length > 0 &&
    tableData?.filter((row) => {
      const fullName = `${row.FirstName} ${row.LastName}`?.toLowerCase();
      const searchTermNormalized = searchTerm?.trim()?.toLowerCase();
      return fullName.includes(searchTermNormalized);
    });
  const handlePrint = () => {
    if (tableRef.current) {
      const tableHTML = tableRef.current.outerHTML;
      const printWindow = window.open("", "_blank");
      printWindow.document.write(`
  
          <html>
            <head>
              <title>Lab Compliance Print</title>
              <style>
                body {
                  font-family: Arial, sans-serif;
                  padding: 20px;
                }
                table {
                  width: 100%;
                  border-collapse: collapse;
                }
                th, td {
                  border: 1px solid #ccc;
                  padding: 8px;
                  text-align: left;
                }
                    th {
                    background-color: #f4f4f4;
                    font-size:16px;
                  }
                    td{
                    font-size:14px}
                          @media print {
    .hide-on-print {
      display: none !important;
    }
  }
              </style>
            </head>
            <body>
              ${tableHTML}
            </body>
          </html>
        `);

      printWindow.document.close();
      printWindow.print();
    } else {
      console.error("Table reference is not set.");
    }
  };

  const handleExcel = (dataTableRef) => {
    if (dataTableRef.current) {
      const tableHtml = dataTableRef.current.innerHTML;
      const data = { PrintableData: tableHtml, PageName: "Lab Compliance New" };
      request(`${process.env.REACT_APP_LOGIN_API_URL}/DataExport/Excel`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        data: JSON.stringify(JSON.stringify(data)),
      })
        .then((res) => {
          const fileUrl = res[2]; // Assuming the URL is in the third position of the response array
          if (fileUrl) {
            // Create a temporary anchor element
            window.open(fileUrl, "_blank");
          } else {
            throw new Error("No download URL provided");
          }
        })
        .catch(() => {
          toast.error("Error occured while generating excel", {
            autoClose: 3000,
          });
        });
    }
    // Add your logic for Excel export here
  };

  const handlePdf = (dataTableRef) => {
    if (dataTableRef.current) {
      const tableHtml = dataTableRef.current.innerHTML;
      const data = { PrintableData: tableHtml, PageName: "Lab Compliance New" }; //static
      request(`${process.env.REACT_APP_LOGIN_API_URL}/DataExport/PDF`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        data: JSON.stringify(JSON.stringify(data)),
      })
        .then((res) => {
          const fileUrl = res[2]; // Assuming the URL is in the third position of the response array
          if (fileUrl) {
            // Create a temporary anchor element
            window.open(fileUrl, "_blank");
          } else {
            throw new Error("No download URL provided");
          }
        })
        .catch(() => {
          toast.error("Error occured while generating pdf", {
            autoClose: 3000,
          });
        });
    }
  };
  return (
    <div className="flex flex-row min-h-screen">
      {/* <SidebarComponent main={false} /> */}
      <div>
        <header className="bg-blue-500 text-white p-4 flex items-center w-full">
          <div className="flex items-center space-x-4">
            <label
              htmlFor="from-date"
              className="block text-md font-medium text-white-300"
            >
              From:
            </label>
            <input
              type="date"
              id="from-date"
              value={formatDateForInput(fromDate)}
              onChange={(e) => {
                const dateString = e.target.value;
                const newDate = parseDateString(dateString);
                if (newDate) {
                  setFromDate(newDate); // Update the state with Date object
                  setError(""); // Clear any previous errors
                } else {
                  setError("Invalid date format.");
                }
              }}
              className="mt-1 block w-[200px] px-3 py-2 border border-gray-600 rounded-md bg-white text-black shadow-sm focus:outline-none focus:ring focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
            />
            {/* </div> */}
            {/* <div> */}
            <label
              htmlFor="to-date"
              className="block text-md font-medium text-white-300"
            >
              To:
            </label>
            <input
              type="date"
              id="to-date"
              value={formatDateForInput(toDate)}
              onChange={(e) => {
                const dateString = e.target.value;
                const newDate = parseDateString(dateString);
                if (newDate) {
                  setToDate(newDate); // Update the state with Date object
                  setError(""); // Clear any previous errors
                } else {
                  setError("Invalid date format.");
                }
              }}
              className="mt-1 block w-[200px]  px-3 py-2 border border-gray-600 rounded-md bg-white text-black shadow-sm focus:outline-none focus:ring focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
            />
            {/* <input
            type="checkbox"
            checked={isCheckedIn}
            onChange={(e) => {
              setIsCheckedIn(e.target.checked);
            }}
          />
          <label>Checked In</label> */}
            {/* </div> */}
            <button
              onClick={handleSearch}
              className="flex items-center bg-orange text-white py-2 px-4 rounded-md shadow-sm focus:outline-none"
            >
              <FaSearch className="mr-2" />
              Search
            </button>
            <div className="flex justify-between gap-4 p-2">
              <button
                onClick={handlePrint}
                className="text-blue-700 hover:text-blue-700 flex flex-col items-center transition-colors"
                title="Print"
              >
                <FaPrint size={24} />
                Print
              </button>
              <button
                onClick={handleExcel}
                className="text-green-700 flex flex-col items-center transition-colors"
                title="Export to Excel"
              >
                <AiOutlineFileExcel size={24} />
                Export as Excel
              </button>
              <button
                onClick={handlePdf}
                className="text-red-700 flex flex-col items-center transition-colors"
                title="Export to PDF"
              >
                <MdPictureAsPdf size={24} />
                Export as PDF
              </button>
            </div>
          </div>
        </header>

        <div className="overflow-auto">
          <table
            ref={tableRef}
            className="min-w-full bg-white border border-gray-300"
          >
            <thead>
              <tr className="bg-blue-400 border-b text-white">
                <th style={{ whiteSpace: "nowrap" }} className="p-2 border-r">
                  #
                </th>
                <th style={{ whiteSpace: "nowrap" }} className="p-2 border-r">
                  DOS
                </th>
                <th style={{ whiteSpace: "nowrap" }} className="p-2 border-r">
                  Patient Name <br></br>
                  <input
                    type="text"
                    className="text-gray-800 text-sm mt-1 hide-on-print"
                    placeholder="Search"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    style={{ marginBottom: "10px", padding: "5px" }}
                  />
                </th>

                <th style={{ whiteSpace: "nowrap" }} className="p-2 border-r">
                  DOB
                </th>
                <th style={{ whiteSpace: "nowrap" }} className="p-2 border-r">
                  POC
                </th>
                <th style={{ whiteSpace: "nowrap" }} className="p-2 border-r">
                  Screening
                </th>
                <th style={{ whiteSpace: "nowrap" }} className="p-2 border-r">
                  Req
                </th>
                <th style={{ whiteSpace: "nowrap" }} className="p-2 border-r">
                  Confirmation
                </th>
                <th style={{ whiteSpace: "nowrap" }} className="p-2 border-r">
                  Blood
                </th>
                <th style={{ whiteSpace: "nowrap" }} className="p-2 border-r">
                  STI
                </th>
                <th style={{ whiteSpace: "nowrap" }} className="p-2 border-r">
                  Provider
                </th>
              </tr>
            </thead>
            <tbody>
              {tableData && Array.isArray(tableData) ? (
                (searchTerm !== "" ? filteredPatients : tableData).map(
                  (row, index) => (
                    <tr key={row.id} data-tooltip-place="top">
                      <td
                        style={{ whiteSpace: "nowrap" }}
                        className="p-2 border-r border-b"
                      >
                        {index + 1}
                      </td>
                      <td
                        style={{ whiteSpace: "nowrap" }}
                        className="p-2 border-r border-b"
                      >
                        {row?.DOS}
                      </td>
                      <td
                        style={{ whiteSpace: "nowrap" }}
                        className="p-2 border-r border-b"
                      >
                        {row.FirstName}, {row.LastName}
                      </td>

                      <td
                        style={{ whiteSpace: "nowrap", cursor: "pointer" }}
                        className="p-2 border-r border-b"
                        onClick={() =>
                          (window.location.href = `/patient/${row.PatientID}`)
                        }
                      >
                        {row?.DOB}
                      </td>
                      <td
                        style={{ whiteSpace: "nowrap" }}
                        className="p-2 border-r border-b"
                        onClick={() =>
                          (window.location.href = `${row?.POCFilePath}`)
                        }
                      >
                        {row?.POCFilePath}
                      </td>
                      <td
                        style={{ whiteSpace: "nowrap" }}
                        className="p-2 border-r border-b"
                        onClick={() =>
                          (window.location.href = `${row?.CNFFilePath}`)
                        }
                      >
                        {row?.CNFFilePath}
                      </td>

                      <td
                        style={{ whiteSpace: "nowrap" }}
                        className="p-2 border-r border-b"
                      >
                        {row?.BloodFilePath && (
                          <a
                            href={row.BloodFilePath}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="cursor-pointer"
                          >
                            <FaFilePdf className="text-red-400" />
                          </a>
                        )}
                      </td>
                      <td
                        style={{ whiteSpace: "nowrap" }}
                        className="p-2 border-r border-b"
                      >
                        {row?.LastCNFDOS}
                      </td>
                      <td
                        style={{ whiteSpace: "nowrap" }}
                        className="p-2 border-r border-b"
                      >
                        {row?.NextCNFDOS}
                      </td>
                    </tr>
                  ),
                )
              ) : (
                <tr>
                  <td colSpan={11} className="p-2 text-center">
                    No data available
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default LabCompliancePopup;
